import React from "react";
import { similar_properties } from "../../../Assets/Rooms";
import { useState, useEffect } from "react";
import { CiDiscount1 } from "react-icons/ci";
import AOS from "aos";
import "aos/dist/aos.css";

function Similar_properties() {
  const [data, setData] = useState([]);

  useEffect(() => {
    setData(similar_properties);
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000, // Duration of the animation
      easing: "ease-in-out",
      once: false,
      offset: 100,  // Trigger when the element is 100px from the viewport
  delay: 200, // Animation triggers only once
    });
  }, []);

  return (
    <div className="xl:px-11 px-4 md:px-8 py-7">
      <h1 className="lg:text-2xl sm:text-2xl text-xl volcano font-bold lg:pl-1 xl:pl-0">
        Other Similar Properties
      </h1>
      <div className="flex justify-between items-center xl:gap-7 gap-4 sm:gap-2 py-5 md:flex-row flex-col">
        {data.map((i) => {
          return (
            <div
              data-aos="flip-left"
              data-aos-easing="ease-out-cubic"
              data-aos-duration="2000"
              className="xl:w-[350px] xl:h-[450px] lg:w-[350px] lg:h-[380px] w-full sm:w-[30vw] h-auto border-[1px] shadow-xl"
            >
              <img
                src={i.image}
                alt=""
                className="xl:h-[290px] h-[200px] w-full object-cover p-2"
              />
              <div className="flex justify-around items-start flex-col border-b-[1px] border-[#D3D3D3] pt-2 pb-3 gap-2 px-4">
                <p className="font-fontStyleDmSans font-bold lg:text-xl text-[16px]">
                  {i.name}
                </p>
                <p className="lg:text-[13px] text-[12px] font-fontStyleDmSans text-[#929292]">
                  <span className="text-[#04BCC2]">{i.gender}</span> PG in
                  Bhubaneswar
                </p>
              </div>
              <div className="flex justify-between items-center px-4 sm:pt-4 gap-1 lg:gap-0 md:pb-4 lg:pb-0 py-2 ">
                <div className="flex justify-center items-start flex-col lg:gap-2 gap-1">
                  <p className="xl:text-[14px] sm:text-[15px] text-[14px] text-[#A8A8A8] volcano">
                    Start's from
                  </p>
                  <p className="xl:text-[19px] sm:text-[17px] text-[16px] text-[#2F2F2F] volcano font-bold">
                    {i.price}
                  </p>
                </div>
                <div className="xl:h-[45px] xl:w-[150px] lg:h-[45px] md:h-[30px] h-[28px] w-full sm:w-[170px] bg-[#DDF6FF] flex justify-center items-center">
                  <CiDiscount1 className="lg:h-[23px] lg:w-[24px] h-[19px] w-[21px] text-[#00C5C8]"></CiDiscount1>
                  <p className="lg:text-[15px] text-[11px] text-[#00C5C8]">
                    {i.off}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Similar_properties;
